export default "__VITE_ASSET__BdnwGMQJ__"